import React, { Component } from "react";
import '@uppy/core/dist/style.css'
import '@uppy/dashboard/dist/style.css'
import { connect } from "react-redux";
import Swal from "sweetalert2";
import Select from "react-select";
import { addApp, updateApp } from '../../../../../../../actions/sceneActions'
import './calendar/calendar.css'
import { customClass, getInitialRoute, stripTrailingSlash } from '../../../../../../../utils'
import './calendar/calendar.css'
import {
    Card,
    Button,
    Row,
    Col,
    Form,
} from "react-bootstrap";
import { DISPLAY_APPS_SUCCESS_SAVE, SUCCESS_TEXT } from "../../messageText";
import CalendarPreview from "../../../_metronic/_partials/apps/calendar";
import moment from 'moment';
import { NavigationHeader } from "../../../_metronic/layout/components/navigationheader/NavigationHeader";
import { GOOGLE_CLIENT_ID } from "../../../../../../../actions/constant";
import { FontAwesomeIcon } from "../../../../../../CommonComponents/AssetsHelper";
const calendarOptions = [
    { value: "0", label: "Month Calendar" },
    { value: "1", label: "Week Calendar" },
    { value: "2", label: "Day Calendar" },
];
const numEventOptions = [
    { value: "1", label: "1" },
    { value: "2", label: "2" },
    { value: "3", label: "3" },
    { value: "4", label: "4" },
    { value: "5", label: "5" },
];
class Calendar extends Component {
    state = {
        updateApi: false,
        calendarType: "2",
        upcomingEventsList: [],
        numEvents: "3",
        events: [],
        gclogin: null,
        CLIENT_ID: GOOGLE_CLIENT_ID,
        SCOPES: "https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/calendar.readonly https://www.googleapis.com/auth/calendar.events https://www.googleapis.com/auth/calendar",
        API_KEY: 'AIzaSyDaUZpZoIGxcWAMigdY-sz-4l83qSVqvrQ',
        buttonDis: false,
        loader: false
    }


    componentDidMount() {
        const { scenes, location } = this.props;
        const { app_data } = scenes.updateSceneData;
        if (app_data && location.pathname.includes('update')) {
            const { calendarType, numEvents, events } = app_data;
            this.setState({ calendarType, numEvents, events, updateApi: true }, () => this.getupcomingEvents());
        }

        const script = document.createElement("script");
        script.async = true;
        script.defer = true;
        script.src = "https://apis.google.com/js/api.js";
        document.body.appendChild(script);

        if (this.state.events && this.state.events.length == 0 && !app_data) {
            script.addEventListener("load", () => {
                if (window.gapi) this.handleClientLoad();
            });
        }


    }
    changeCalendarType = (event) => {
        this.setState({ calendarType: event.value });
    };
    changeNumEventType = (event) => {
        this.setState({ numEvents: event.value }, () => this.getupcomingEvents());
    };
    onTimerSave = (event) => {
        const { param } = this.props;
        const { calendarType, numEvents, events } = this.state;

        if (calendarType) {

            this.setState({ buttonDis: true, loader: true })
            this.state.updateApi
                ? this.props.updateApp(
                    param.contentMixId,
                    this.props.scenes.updateSceneData.id,
                    { calendarType, numEvents, events },
                    2,
                    this.onSaveCallBack
                )
                : this.props.addApp(
                    param.contentMixId,
                    param.positionID,
                    { calendarType, numEvents, events },
                    "Calendar",
                    2,
                    this.onSaveCallBack
                );
        }
        else {
            Swal.fire({
                title: 'Error',
                text: 'Please check all select!',
                type: "error",
                icon: 'error',
                showConfirmButton: false,
                timer: 3000
            })
        }
    };

    onBack = (event) => {
        const { params } = this.props.match;
        const { pathname } = this.props.location;

        Swal.fire({
            title: "Are you sure?",
            text: "Your changes have not been saved. Do you want to save before you leave the page?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Save",
            cancelButtonText: "Discard Changes",
            reverseButtons: true,
            customClass: customClass

        }).then((result) => {
            if (result.value) {
                this.onTimerSave()
            } else if (result.dismiss === "cancel") {
                this.props.history(stripTrailingSlash(pathname, params))
            }
        });
    };

    onSaveCallBack = () => {
        const { params } = this.props.match;
        Swal.fire({
            title: SUCCESS_TEXT,
            text: DISPLAY_APPS_SUCCESS_SAVE,
            type: "success",
            icon: "success",
            showConfirmButton: false,
            timer: 3000,
        }).then((result) => {
            this.setState({ buttonDis: false, loader: false })
            this.props.history(`/studio/${params.wallId}`);
        });
    };



    handleClientLoad = () => {
        window.gapi.load("client:auth2", this.initClient);
    };


    openSignInPopup = () => {
        window.gapi.auth2.authorize(
            { client_id: this.state.CLIENT_ID, scope: this.state.SCOPES },
            (res) => {
                if (res) {
                    if (res.access_token) {
                        this.setState({ gclogin: res.access_token }, () => this.initClient(res.access_token));
                        // Load calendar events after authentication
                        window.gapi.client.load("calendar", "v3", this.listUpcomingEvents);
                    }
                }
            }
        );
    }

    initClient = (token) => {

        if (!token) {
            this.openSignInPopup();
        } else {
            // Get events if access token is found without sign in popup
            fetch(
                `https://www.googleapis.com/calendar/v3/calendars/primary/events?key=${this.state.API_KEY}&orderBy=startTime&singleEvents=true`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            )
                .then((res) => {
                    // Check if unauthorized status code is return open sign in popup
                    if (res.status !== 401) {
                        return res.json();
                    } else {
                        this.setState({ gclogin: null })
                        this.openSignInPopup();
                    }
                })
                .then((data) => {
                    if (data?.items) {
                        this.setState({ events: this.formatEvents(data.items) })
                        setTimeout(() => {
                            this.getupcomingEvents()
                        }, 1000);
                    }
                })
        }
    };

    formatEvents = (list) => {
        const today = moment().startOf('day');
        return list
            .filter(item1 => {
                const eventDate = moment.utc(item1.start.dateTime || item1.start.date);
                return eventDate.format('MM') == (new Date().getMonth() + 1) && eventDate.isSameOrAfter(today)
            })
            .map((item) => ({
                title: item.summary,
                start: item.start.dateTime || item.start.date,
                end: item.end.dateTime || item.end.date,
                allDay: false,
                date: moment.utc(item.start.dateTime || item.start.date).format('DD')
            }))
            .sort((a, b) => moment(a.start).valueOf() - moment(b.start).valueOf());
    };


    listUpcomingEvents = () => {
        window.gapi.client.calendar.events
            .list({
                // Fetch events from user's primary calendar
                calendarId: "primary",
                showDeleted: true,
                singleEvents: true,
            })
            .then((response) => {
                let events = response.result.items;

                if (events.length > 0) {
                    this.setState({ events: this.formatEvents(events) });
                }
            });
    };

    logoutGoogleCalendar = () => {
        this.setState({ gclogin: '', events: [] });
    }

    getupcomingEvents = () => {
        const { events, numEvents } = this.state;
        let count = 0;
        let updatedEvents = (events && events.length > 0) ? events.filter((item) => {
            if (count < parseInt(numEvents) && moment(item.end).format("DD/MM/YYYY HH:mm:ss") >= moment().format("DD/MM/YYYY HH:mm:ss")) {
                count++; return true;
            }
            else return false;
        }) : []

        this.setState({
            upcomingEventsList: updatedEvents
        })
    }

    render() {
        const { match, name } = this.props;
        const { calendarType, numEvents, buttonDis, loader, gclogin, updateApi } = this.state;
        const { pathname } = this.props.location;

        return (
            <>
                {!updateApi ?
                    <NavigationHeader
                        name={name}
                        backToNavigation={`${pathname ? stripTrailingSlash(pathname, match) : ''}`}
                    /> : null}
                <div className="container-fluid subheader_content">
                    <Card className="select_wall mb-3 rounded-0 border-0">
                        <Card.Body className="p-0">
                            <Row>
                                <Col lg={4} className="border-right-lg">
                                    <Card className="border-0 rounded-0">
                                        <Card.Body className="p-4 card_height">
                                            <Form.Group className="form-group" controlId="calendar-format">
                                                {!gclogin ?
                                                    <Button variant="outline-dark" className="googleConnect btn-hover-primary me-2" onClick={this.handleClientLoad} >
                                                        <FontAwesomeIcon type={'brands'} icon={'google'} iconClass={'me-2'} /> Login With Google
                                                    </Button> :
                                                    <>
                                                        <Button variant="outline-dark" className="btn-hover-primary googleConnect me-2"
                                                            onClick={this.logoutGoogleCalendar} >
                                                            <FontAwesomeIcon type={'brands'} icon={'google'} iconClass={'me-2'} /> Logout
                                                        </Button>
                                                        <Button variant="outline-dark" className="btn-hover-primary googleConnect me-2" onClick={this.handleClientLoad} >
                                                            <FontAwesomeIcon type={'brands'} icon={'google'} iconClass={'me-2'} /> update
                                                        </Button>
                                                    </>

                                                }
                                            </Form.Group>
                                            <Form.Group className="form-group" controlId="calendar-format">
                                                <Form.Label>Calendar Type</Form.Label>
                                                <Select
                                                    value={calendarOptions.find(option => option.value === calendarType)}
                                                    onChange={this.changeCalendarType}
                                                    options={calendarOptions}
                                                    defaultValue={{ value: "2", label: "Day Calendar" }}

                                                />
                                            </Form.Group>
                                            <Form.Group className="form-group" controlId="calendar-format">
                                                <Form.Label>Show Number of Events</Form.Label>
                                                <Select
                                                    value={numEventOptions.find(option => option.value === numEvents)}
                                                    onChange={this.changeNumEventType}
                                                    options={numEventOptions}
                                                    defaultValue={{ value: "3", label: "4" }}
                                                />
                                            </Form.Group>
                                        </Card.Body>
                                        <Card.Footer className="bg-transparent d-flex justify-content-end border-0 p-4">
                                            <button
                                                className="btn btn-outline-dark me-3 btn-min-w"
                                                onClick={this.onBack}
                                            >
                                                <span className="position-relative">Back</span>
                                            </button>
                                            <Button
                                                variant="primary"
                                                disabled={buttonDis}
                                                className={`btn btn-primary btn-min-w ${loader ? `spinner spinner-white spinner-right disabled` : null}`}
                                                onClick={this.onTimerSave}
                                                id="Studio_Calendar_App_Users"
                                            >
                                                Save
                                            </Button>
                                        </Card.Footer>
                                    </Card>
                                </Col>
                                <Col
                                    lg={8}
                                    className="d-flex align-items-center justify-content-center"
                                >
                                    <Card className="border-0 card w-100">
                                        <Card.Body className="border-0">
                                            <div className="wall_view">
                                                <div className="wall_view_wrapper">
                                                    <CalendarPreview {...this.state} />
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </div>
            </>

        );
    }
}

const mapStateToProps = state => {
    return {
        scenes: state.scene,
        studioWall: state.studio.studioWal
    }
}
const mapDispatchToProps = dispatch => {
    return {

        addApp: (contentMixId, position, appContent, appName, appId, callBack) =>
            dispatch(
                addApp(contentMixId, position, appContent, appName, appId, callBack)
            ),
        updateApp: (contentMixId, sceneContentId, appContent, appId, callBack) =>
            dispatch(
                updateApp(contentMixId, sceneContentId, appContent, appId, callBack)
            ),
    }
}



export default connect(mapStateToProps, mapDispatchToProps)(Calendar);


